let addonid = '';
function addOnPrice(){
   var priceItemRegular =  $('.product__info-wrapper .mn_price .price-item').attr('data-price') / 100;
  var add_single_price = $('.pair_it_section .price-item.price-item--regular').attr('data-sl-price');
  var add_single_pricex2 = add_single_price * 2;
  var priceItemRegularx2 = priceItemRegular * 2;
  var addon_regular_price = parseFloat(priceItemRegular) + parseInt(add_single_price);
  var addon_regular_pricex2 = parseFloat(add_single_pricex2) + parseInt(priceItemRegularx2);
   console.log('test000');
  var currencySymbol = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencySymbol;
  var currencyCode = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencyCode;

        var isoLanguageCode = 'en-AU';
        switch (currencyCode) {
          case 'EUR':
            isoLanguageCode = 'en-US';
            break;
          case 'VND':
            isoLanguageCode = 'vi-VN';
            break;
          case 'CAD':
            isoLanguageCode = 'en-CA';
            break;
          case 'CNY':
            isoLanguageCode = 'zh-CN';
            break;
          case 'DKK':
            isoLanguageCode = 'da-DK';
            break;
          case 'FJD':
            currencyCode = 'AUD';
            break;
          case 'HKD':
            currencyCode = 'AUD';
            break;
          case 'HUF':
            isoLanguageCode = 'hu-US';
            break;
          case 'IDR':
            isoLanguageCode = 'id-US';
            break;
          case 'JPY':
            isoLanguageCode = 'ja-JP';
            break;
          case 'MYR':
            isoLanguageCode = 'ms-MY';
            break;
          case 'PHP':
            isoLanguageCode = 'fil-PH';
            break;
          case 'SGD':
            isoLanguageCode = 'en-SG';
            break;
          case 'KRW':
            isoLanguageCode = 'ko-KR';
            break;
          case 'SEK':
            isoLanguageCode = 'sv-SE';
            break;
          case 'THB':
            isoLanguageCode = 'th-TH';
            break;
          case 'GBP':
            isoLanguageCode = 'en-UK';
            break;
        }

        var formatter = new Intl.NumberFormat(isoLanguageCode, {
          style: 'currency',
          currency: currencyCode,
        });

   var addon_regular_price = formatter.format(addon_regular_price);
   $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_price);
}

function checkOnLoad(){
  if($('.pair_it_section').length>0){
    // addOnPrice();  
  }
}
checkOnLoad();

function updateAddonId(selectElement) {
  var priceItemRegular =  $('.product__info-wrapper .mn_price .price-item').attr('data-price') / 100;
  var add_single_price = $('.pair_it_section .price-item.price-item--regular').attr('data-sl-price');
  var add_single_pricex2 = add_single_price * 2;
  var priceItemRegularx2 = priceItemRegular * 2;
  var addon_regular_price = parseFloat(priceItemRegular) + parseInt(add_single_price);
  var addon_regular_pricex2 = parseFloat(add_single_pricex2) + parseInt(priceItemRegularx2);
  var selectedOption = selectElement.options[selectElement.selectedIndex];
  var variantId = selectedOption.getAttribute('data-variant-id');
  addonid = variantId;
   var elements = document.querySelectorAll('.has_addon.product-form__submit');
    elements.forEach(function(element) {
        element.disabled = false;
    });
  var currencySymbol = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencySymbol;
  var currencyCode = document.querySelector('#HeaderCountryForm .localization-selector').dataset.currencyCode;

        var isoLanguageCode = 'en-AU';
        switch (currencyCode) {
          case 'EUR':
            isoLanguageCode = 'en-US';
            break;
          case 'VND':
            isoLanguageCode = 'vi-VN';
            break;
          case 'CAD':
            isoLanguageCode = 'en-CA';
            break;
          case 'CNY':
            isoLanguageCode = 'zh-CN';
            break;
          case 'DKK':
            isoLanguageCode = 'da-DK';
            break;
          case 'FJD':
            currencyCode = 'AUD';
            break;
          case 'HKD':
            currencyCode = 'AUD';
            break;
          case 'HUF':
            isoLanguageCode = 'hu-US';
            break;
          case 'IDR':
            isoLanguageCode = 'id-US';
            break;
          case 'JPY':
            isoLanguageCode = 'ja-JP';
            break;
          case 'MYR':
            isoLanguageCode = 'ms-MY';
            break;
          case 'PHP':
            isoLanguageCode = 'fil-PH';
            break;
          case 'SGD':
            isoLanguageCode = 'en-SG';
            break;
          case 'KRW':
            isoLanguageCode = 'ko-KR';
            break;
          case 'SEK':
            isoLanguageCode = 'sv-SE';
            break;
          case 'THB':
            isoLanguageCode = 'th-TH';
            break;
          case 'GBP':
            isoLanguageCode = 'en-UK';
            break;
        }

        var formatter = new Intl.NumberFormat(isoLanguageCode, {
          style: 'currency',
          currency: currencyCode,
        });
        var checkaddonSElect = $('.variant-wrapper.addon .select__select').val();
          if (checkaddonSElect) {
                if (ctmqtyValue == 1) {
               var addon_regular_price = formatter.format(addon_regular_price);
                    $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_price);
            }
            if (ctmqtyValue == 2) {
               var addon_regular_pricex2 = formatter.format(addon_regular_pricex2);
                $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(addon_regular_pricex2);
            }
          }
           else {
               var priceItemRegular = formatter.format(priceItemRegular);
              var priceItemRegularx2 = formatter.format(priceItemRegularx2);
             if (ctmqtyValue == 1) {
               $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(priceItemRegular);
             }
             if (ctmqtyValue == 2) {
                $('.product__info-wrapper .mn_price .price-item.price-item--regular').text(priceItemRegularx2);
             }
            }
}


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      let storeThis = this;
      let addonqyt=1;
        let addonqySelector = document.querySelector('.addon_qyt_main .addon_qyt');
        if (addonqySelector) {
          addonqyt = addonqySelector.getAttribute('data-qyt');
        }
      console.log('QYT' + addonqyt);
      $.ajax({
            type: 'POST',
            url: 'https://www.covetear.com/cart/add.js',
            data: {
              quantity: addonqyt,
              id: addonid
            },
            dataType: 'json', 
            success: function () {
                  fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    storeThis.handleErrorMessage(response.description);
        
                    const soldOutMessage = storeThis.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    storeThis.submitButton.setAttribute('aria-disabled', true);
                    storeThis.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    storeThis.error = true;
                    return;
                  } else if (!storeThis.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                  
                  if (!storeThis.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
                  storeThis.error = false;
                  const quickAddModal = storeThis.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener('modalClosed', () => {
                      setTimeout(() => {
                        storeThis.cart.renderContents(response);
                      });
                    }, { once: true });
                    quickAddModal.hide(true);
                  } else {
                    storeThis.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  storeThis.submitButton.classList.remove('loading');
                  if (storeThis.cart && storeThis.cart.classList.contains('is-empty')) storeThis.cart.classList.remove('is-empty');
                  if (!storeThis.error) storeThis.submitButton.removeAttribute('aria-disabled');
                  storeThis.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            },
           error: function() {
                 fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    storeThis.handleErrorMessage(response.description);
        
                    const soldOutMessage = storeThis.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    storeThis.submitButton.setAttribute('aria-disabled', true);
                    storeThis.submitButton.querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    storeThis.error = true;
                    return;
                  } else if (!storeThis.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                  
                  if (!storeThis.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
                  storeThis.error = false;
                  const quickAddModal = storeThis.closest('quick-add-modal');
                  if (quickAddModal) {
                    document.body.addEventListener('modalClosed', () => {
                      setTimeout(() => {
                        storeThis.cart.renderContents(response);
                      });
                    }, { once: true });
                    quickAddModal.hide(true);
                  } else {
                    storeThis.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  storeThis.submitButton.classList.remove('loading');
                  if (storeThis.cart && storeThis.cart.classList.contains('is-empty')) storeThis.cart.classList.remove('is-empty');
                  if (!storeThis.error) storeThis.submitButton.removeAttribute('aria-disabled');
                  storeThis.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            }
        });
  }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
